import axios from "axios";
export default class ApiStores {
    static async GetStoresList(session_uuid) {
        try {
            const result = await axios.get("/api/admin/get-sales-points", {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.data;
        }
        catch (e) {
            return false;
        }
    }
    static async GetCoordinatesAddress(session_uuid, address, city, province) {
        try {
            let url = "/api/admin/get-geocode-address?address=" + encodeURIComponent(address) + "&city=" + encodeURIComponent(city);
            if (province) {
                url += "&province=" + encodeURIComponent(province);
            }
            const result = await axios.get(url, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.data;
        }
        catch (e) {
            return false;
        }
    }
    static async CreateStore(session_uuid, address, longitude, latitude, name, is_hidden, city, province) {
        try {
            const result = await axios.post("/api/admin/create-sale-point", {
                is_hidden: is_hidden,
                address: address,
                city: city,
                province: province,
                longitude: String(longitude),
                latitude: String(latitude),
                store_name: name,
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.data;
        }
        catch (e) {
            return false;
        }
    }
    static async UpdateStore(session_uuid, address, longitude, latitude, name, is_hidden, city, province, uuid) {
        try {
            const result = await axios.post("/api/admin/update-sale-point", {
                is_hidden: is_hidden,
                address: address,
                city: city,
                province: province,
                longitude: String(longitude),
                latitude: String(latitude),
                store_name: name,
                uuid: uuid,
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.data;
        }
        catch (e) {
            return false;
        }
    }
    static async GetStoreByUUID(session_uuid, uuid) {
        try {
            const result = await axios.get("/api/admin/get-sale-point?uuid=" + uuid, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.data;
        }
        catch (e) {
            return false;
        }
    }
    static async DeleteStore(session_uuid, uuid) {
        try {
            const result = await axios.post("/api/admin/delete-sale-point", {
                uuid: uuid,
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.data;
        }
        catch (e) {
            return false;
        }
    }
    static async ChangeStorePublish(session_uuid, uuid, is_hidden) {
        try {
            const result = await axios.post("/api/admin/change-sale-point-publish", {
                uuid: uuid,
                is_hidden: is_hidden,
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.data;
        }
        catch (e) {
            return false;
        }
    }
    static async RefreshSalesPoints(session_uuid) {
        try {
            const result = await axios.post("/api/admin/sales-points/refresh", {}, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.data;
        }
        catch (e) {
            return false;
        }
    }
}
